import RequestClient from '@shared/services/main/request-client';
import UrlModifier from '@shared/lib/helpers/url-modifier';
import Emitter from '@shared/services/main/events';
import { alertSuccess, alertError } from '@shared/services/base/alerts/common-alerts';
import { humanize, toItemName } from '@shared/lib/helpers/common';

/**
 * This prototype describes an Delete events trait. Encapsulate business logics
 *
 * @class      DeleteCallable (name)
 */
function DeleteCallable(component) {
  this.component = component;
}


DeleteCallable.prototype.perpareDeleteParam = function(item_key = 'id', item_id) {
  var params = {};
  params[item_key] = item_id;
  return params;
}

/**
 * Registers Deletes events, this follows naming convention
 *
 * @param      {Object}       self         The caller instance
 * @param      {DeleteCallable}  service      The service
 * @param      {string}       module_name  The module name
 */
DeleteCallable.prototype.registerDeleteEvents = function(self, service) {
  var event_callback_map = {};
  event_callback_map[this.event_group.DELETE_PROCEED] = 'onDeleteProceed';
  event_callback_map[this.event_group.DELETE_SUCCESS] = 'onDeleteSuccess';
  event_callback_map[this.event_group.DELETE_FAIL]    = 'onDeleteFail';
  this.registerEvents(event_callback_map, service);
  return this;
}

/**
 * Removes Delete events.
 *
 * @param      {<type>}  self         The object
 * @param      {<type>}  service      The service
 * @param      {string}  module_name  The module name
 */
DeleteCallable.prototype.removeDeleteEvents = function() {
  this.removeEvents([
    this.event_group.DELETE_PROCEED,
    this.event_group.DELETE_SUCCESS,
    this.event_group.DELETE_FAIL
  ]);
  return this;
}

/**
 * Gives the request extra options,
 *
 * NOTE: this will override the same option keys
 *
 * @return     {Object}  The request extra options
 */
DeleteCallable.prototype.extraDeleteOptions = function() {
  return {};
}

/**
 * Called when Delete proceed.
 *
 * @param      {Object}  options  The options
 */
DeleteCallable.prototype.onDeleteProceed = function({item_key='id', item_id}) {
  console.log("DeleteCallable::onDeleteProceed" , {item_key, item_id});

  this.addInterceptor();

  var url = UrlModifier.bindToUrl(
    this.delete_endpoint,
    this.perpareDeleteParam(item_key, item_id)
  );

  let token_source = this.renewCancelToken(RequestClient, this.event_group.DELETE_PROCEED);
  this.getComponent().setState({loader: true});

  const options = this.extraDeleteOptions();
  let request = RequestClient.delete(url, {
    cancelToken: token_source.token,
    ...options
  });
  this.bindResultEvents(
    request,
    this.event_group.DELETE_SUCCESS,
    this.event_group.DELETE_FAIL
  );
}

/**
 * Called on delete success intercept.
 */
DeleteCallable.prototype.onDeleteInterceptSuccess = function() {
  const item_name = this.item_name || toItemName(this);
  alertSuccess({
    title: 'Delete success',
    message: humanize(item_name) + ' is succesfully deleted'
  });
}

/**
 * Called on Delete success.
 *
 * @param      {Object}  response  The response
 */
DeleteCallable.prototype.onDeleteSuccess = function(response) {
  console.log("DeleteCallable::onDeleteSuccess" , response);

  Emitter.emit(this.event_group.LIST_PROCEED, {});
}

/**
 * Called on Delete fail.
 *
 * @param      {Object}  error   The error
 */
DeleteCallable.prototype.onDeleteFail = function(error) {
  console.log("DeleteCallable::onDeleteFail" , error);

  Emitter.emit(this.event_group.LIST_PROCEED, {});
}

/**
 * Called on delete fail intercept.
 *
 * @param      {Object}  response  The response
 */
DeleteCallable.prototype.onDeleteInterceptFail = function(response) {
  const { data: { message } } = response
  alertError({
    title: 'Delete Failed',
    message: message,
  });
}

export default DeleteCallable;
